import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCalculateEnabled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.25 0H1.75C1.225 0 0.875 0.35 0.875 0.875V13.125C0.875 13.65 1.225 14 1.75 14H12.25C12.775 14 13.125 13.65 13.125 13.125V0.875C13.125 0.35 12.775 0 12.25 0ZM4.375 11.375H2.625V9.625H4.375V11.375ZM4.375 7.875H2.625V6.125H4.375V7.875ZM7.875 11.375H6.125V9.625H7.875V11.375ZM7.875 7.875H6.125V6.125H7.875V7.875ZM11.375 11.375H9.625V6.125H11.375V11.375ZM11.375 4.375H2.625V1.75H11.375V4.375Z",
		fill: "currentColor"
	})
});
export default SvgIconCalculateEnabled;
